/* Tidy Towel (Oct 7 2026, Kevin approved): flip double-sided towel cards in the deal builder (snippets/tt-deal-card.liquid).
   - [data-tt-flip] button toggles .tt-imw.is-flipped + aria-pressed. It runs in the capture phase and stops the event, so a flip
     tap never reaches the builder's select/deselect delegation in assets/tt-deal.js (the button also has no data-tt-* hooks).
   - The back photo (img.tt-back) has no src until the first flip, or the first mouse hover on hover-capable pointers. */
(function () {
  if (window.ttFlip) return; window.ttFlip = 1;
  function load(w) {
    var b = w && w.querySelector('img.tt-back[data-tt-src]'); if (!b) return;
    var ss = b.getAttribute('data-tt-srcset'); if (ss) b.setAttribute('srcset', ss);
    b.setAttribute('src', b.getAttribute('data-tt-src'));
    b.removeAttribute('data-tt-src'); b.removeAttribute('data-tt-srcset');
  }
  document.addEventListener('click', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-tt-flip]') : null; if (!f) return;
    e.preventDefault(); e.stopPropagation();
    var w = f.closest('.tt-imw'); if (!w) return;
    load(w);
    var on = !w.classList.contains('is-flipped');
    w.classList.toggle('is-flipped', on);
    f.setAttribute('aria-pressed', on ? 'true' : 'false');
  }, true);
  var hov = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : null;
  document.addEventListener('mouseover', function (e) {
    if (!hov || !hov.matches) return;
    var w = e.target && e.target.closest ? e.target.closest('.tt-imw.has-back') : null;
    if (w) load(w);
  }, { passive: true });
})();
